var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressNewEntry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe10;}.cls-2{fill:#fffbc5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stress_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_99",
    "data-name": "Layer 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "litter_expenses_new_entry",
    "data-name": "litter expenses new entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.01,
    cy: 300.38,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.33,244.93H357.06V159.75a56.18,56.18,0,0,0-56-56h0a56.2,56.2,0,0,0-56,56v85.18H164.84a56.2,56.2,0,0,0-56,56h0a56.2,56.2,0,0,0,56,56H245V442.2a56.2,56.2,0,0,0,56,56h0a56.2,56.2,0,0,0,56-56V357h90.27a56.18,56.18,0,0,0,56-56h0A56.19,56.19,0,0,0,447.33,244.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressNewEntry);
export default __webpack_public_path__ + "static/media/stress_new_entry.30b1356315e8ca70846d1dbc50dd8bc1.svg";
export { ForwardRef as ReactComponent };